import { useEffect, useState } from "react";

import { Radio, Typography } from "@mui/material";

import { ETimeBreak } from "../../../../../@types";
import { useTeachingPolicy } from "../../../../../hooks/useTeachingPolicy";

const timeBreakOptions = [
	{
		text: "15 minutes",
		value: ETimeBreak.FIFTEEN_MINUTES,
	},
	{
		text: "30 minutes",
		value: ETimeBreak.THIRTY_MINUTES,
	},
	{
		text: "45 minutes",
		value: ETimeBreak.FORTY_FIVE_MINUTES,
	},
	{
		text: "1 hour",
		value: ETimeBreak.ONE_HOUR,
	},
];

export function TimeBreak() {
	const { policy, savePolicy } = useTeachingPolicy();

	const [timeBreak, setTimeBreak] = useState<ETimeBreak | null>(null);

	useEffect(() => {
		if (policy) {
			setTimeBreak(policy.timeBreak);
		}
	}, [policy]);

	return (
		<div className="section-separator">
			<Typography className="small-title-text bold">Time break</Typography>
			<Typography className="normal-text item-separator-tiny">
				Give yourself time to reset between back-to-back lessons and show your
				best to every student.
			</Typography>
			<div className="item-separator-small" />
			{timeBreakOptions.map((option) => {
				return (
					<div
						className="radio-item-container"
						key={option.text}
						onClick={() => {
							if (option.value !== timeBreak) {
								setTimeBreak(option.value);
								savePolicy({ timeBreak: option.value });
							}
						}}>
						<Radio checked={timeBreak === option.value} size="small" />
						<Typography className="normal-text">{option.text}</Typography>
					</div>
				);
			})}
		</div>
	);
}
